import { Guid } from "@/Common/Models/Guid";
import { FlowsheetTemplateClient } from "../Api/FlowsheetTemplatesClient";
import getFlowsheetTemplateResponseToFlowsheetTemplate from "../Mappers/GetFlowsheetTemplateResponseToFlowsheetTemplateMapper";
import { FlowsheetTemplate } from "../Models/FlowsheetTemplate";
import { IUseQueryResponse, useQuery } from "./useQuery";

function useFlowsheetTemplate(templateId: Guid): IUseQueryResponse<FlowsheetTemplate> {
    return useQuery({
        query: async () => {
            const response = await FlowsheetTemplateClient.getFlowsheetTemplate(templateId);

            response.throwIfError();

            return getFlowsheetTemplateResponseToFlowsheetTemplate(response.data);
        }
    });
}

export {
    useFlowsheetTemplate
};
